export const quickTextTemplateActions = {
  openTemplateModal: (state, action) => {
    state.selectedTemplate = action.payload.selectedTemplate;
    state.showModal = action.payload.showModal;
    state.modalTitle = action.payload.modalTitle;
  },
  setLoading: (state, action) => {
    state.isLoading = action.payload;
  },
  setTableFilters: (state, action) => {
    state.filters = action.payload;
  },
  closeTemplateModal: (state) => {
    state.showModal = false;
  },
  setSelectedTemplate: (state, action) => {
    state.selectedTemplate = action.payload;
  },
  changeSearch: (state, action) => {
    state.searchText = action.payload;
  },
  openConfirmModal: (state, action) => {
    state.showConfirmModal = true;
    state.templateToDelete = action.payload.templateToDelete;
  },
  closeConfirmModal: (state) => {
    state.showConfirmModal = false;
    state.templateToDelete = null;
  },
  refetchQuickTextTemplateList: (state, action) => {
    state.shouldRefetch = action.payload;
  },
};
